<template>
  <div id="alterations">
    <div class="header-text">
      <h1>修改密码</h1>
    </div>

    <div>
      <el-card shadow="never" class="centercard">
        <div class="centercardForm">
          <el-form
            :model="Password"
            :rules="PasswordRules"
            ref="PasswordRef"
            label-width="100px"
            class="demo-ruleForm"
            size="small"
            :label-position="labelPosition"
          >
            <el-form-item label="员工编号" prop="empCode">
              <el-input :disabled="true" v-model="Password.empCode"></el-input>
            </el-form-item>
            <el-form-item label="原密码" prop="oldPwd">
              <el-input
                show-password
                placeholder="请输入原密码"
                v-model="Password.oldPwd"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
              <el-input
                placeholder="请输入新密码"
                show-password
                v-model="Password.newPwd"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPwd">
              <el-input
                placeholder="请确认新密码"
                show-password
                v-model="Password.confirmPwd"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                style="width: 36%"
                @click="resetpassword('PasswordRef')"
                >修改密码</el-button
              >
              <el-button style="width: 36%; margin-left: 15%" @click="returnq"
                >返回</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { SysempupdatePwd } from "@/api/user";
import { getUserRights } from "@/api/login.js";
export default {
  name: "alterations",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.Password.confirmPwd !== "") {
          this.$refs.PasswordRef.validateField("confirmPwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.Password.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "left",
      empCode: "",
      Password: {
        empCode: "", //员工编号
        oldPwd: "", //旧密码
        newPwd: "", //新密码
        confirmPwd: "", // 确认新密码
      },
      PasswordRules: {
        oldPwd: [
          { required: true, message: "请输入原密码", trigger: "change" },
          {
            pattern:
              /^([`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]|[A-Za-z0-9])+$/,
            message: "密码格式不正确",
            trigger: "blur",
          },
        ],
        newPwd: [
          { validator: validatePass, trigger: "change" },
          {
            pattern:
              /^([`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]|[A-Za-z0-9])+$/,
            message: "密码格式不正确",
            trigger: "blur",
          },
        ],
        confirmPwd: [
          { validator: validatePass2, trigger: "change" },
          {
            pattern:
              /^([`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]|[A-Za-z0-9])+$/,
            message: "确认密码格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getempCode();
  },
  methods: {
    getempCode() {
      getUserRights({}).then((res) => {
        this.Password.empCode = res.empCode;
        this.empCode = res.empCode;
      });
    },
    // 重置密码
    resetpassword(PasswordRef) {
      this.$refs[PasswordRef].validate(async (valid) => {
        if (!valid) return;
        SysempupdatePwd(this.Password).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改密码失败!");
            return;
          } else {
            this.$message.success("修改密码成功!");
            this.$refs.PasswordRef.resetFields();

            this.Password.empCode = this.empCode;
            // this.Password.newPwd = "",
            // this.Password.confirmPwd = "",
            // this.Password.oldPwd = ""
          }
        });
      });
    },
    // 返回
    returnq() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style lang="scss" scoped>
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

.centercard {
  margin-top: 10px;
}
.centercardForm {
  width: 500px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
</style>
